import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TestAuth } from './TestAuth';

@Injectable({
  providedIn: 'root'
})
export class TestAuthGuard implements CanActivate {
  constructor(private testAuth: TestAuth, private router: Router) {}

  canActivate(): boolean {
    if (!this.testAuth.hasCrmSession()) {
      this.router.navigate(['/login']);
      return false;
    }

    if (this.testAuth.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/test/login']);
    return false;
  }
}